import { render, staticRenderFns } from "./coursePurchase.vue?vue&type=template&id=0ced4675&scoped=true"
import script from "./coursePurchase.vue?vue&type=script&lang=js"
export * from "./coursePurchase.vue?vue&type=script&lang=js"
import style0 from "./coursePurchase.vue?vue&type=style&index=0&id=0ced4675&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ced4675",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ced4675')) {
      api.createRecord('0ced4675', component.options)
    } else {
      api.reload('0ced4675', component.options)
    }
    module.hot.accept("./coursePurchase.vue?vue&type=template&id=0ced4675&scoped=true", function () {
      api.rerender('0ced4675', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/merchantInfo/coursePurchase.vue"
export default component.exports